import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const EmployeeReferenceCardContainer = styled.div`
  background: #fff;
  width: 100%;
  min-height: 284px;
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NoEmployeeLabel = styled.p`
  text-align: center;
  margin: 10px;
  font-weight: 700;
`

export const InfoIcon = styled(FontAwesomeIcon)`
  color: #000000;
  justify-content: flex-end;
`
